import React, { useState, useRef } from "react";
import { db } from "../firebase";
import { doc, setDoc } from "firebase/firestore";
import Modal from "./Modal";
import { useModal } from "../contexts/ModalContext";

export default function Contact() {
  const nameRef = useRef();
  const emailRef = useRef();
  const messageRef = useRef();
  const [loading, setLoading] = useState(false);
  const { modalState, modalDispatch } = useModal();

  async function handleSubmit(e) {
    e.preventDefault();
    const timestamp = new Date().getTime();
    setLoading(true);
    try {
      await setDoc(doc(db, "messages", `${timestamp}`), {
        name: nameRef.current.value,
        email: emailRef.current.value,
        message: messageRef.current.value,
      });
      modalDispatch({ type: "SHOW_SUCCESS", payload: "Message sent successfully" });
      setLoading(false);
    } catch (e) {
      modalDispatch({ type: "SHOW_ERROR", payload: "Failed to send message, error: " + e });
      setLoading(false);
    }
  }
  return (
    <>
      <div className="section-container reading-sections">
        {modalState.showModal && <Modal />}
        <section className="main-about-section">
          <h1 className="section-header contact">Contact</h1>
          <h2 className="section-subheader contact top-600">EMAIL: info@dispassion.blog</h2>
        </section>
        <section className="form-section contact">
          <div className="form-field contact">
            {/* <h2 className="form-header contact">Contact Form</h2> */}
            <form onSubmit={handleSubmit}>
              <div id="name" className="flex-column form-var">
                <label>Name</label>
                <input
                  className="form-input"
                  type="name"
                  autoComplete="name"
                  ref={nameRef}
                  required
                />
              </div>
              <div id="email" className="flex-column form-var">
                <label>Email</label>
                <input
                  className="form-input"
                  type="email"
                  autoComplete="email"
                  ref={emailRef}
                  required
                />
              </div>
              <div id="message" className="flex-column form-var">
                <label>Message</label>
                <textarea
                  className="message form-input"
                  name="message"
                  rows="8"
                  ref={messageRef}
                  required
                ></textarea>
              </div>
              <button disabled={loading} className="btn form-btn contact" type="submit">
                Submit
              </button>
            </form>
          </div>
        </section>
      </div>
    </>
  );
}
